import script from "./deboneCost.vue?vue&type=script&setup=true&lang=js"
export * from "./deboneCost.vue?vue&type=script&setup=true&lang=js"

import "./deboneCost.vue?vue&type=style&index=0&id=f75a84b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f75a84b0"]])

export default __exports__